import React, { FC, ReactNode, useState, useMemo, useContext, useRef } from 'react';
import { ResourceViewerContext, ResourceViewerContextType } from '@insync-students-components/ResourceViewer/stores/resourceViewerContext';
import { useVisibilityConfig } from '@insync-students-components/ResourceViewer/hooks/useVisibilityConfig/useVisibilityConfig.hook';
import { Assignment } from '@insync-students-lib/models';
import { CmsResource } from '@insync-students-lib/services/cms/cms-api.types';
import { useResourceView } from '@modules/Resources/useResourceView';
export const ResourceViewerProvider: FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [resource, setResource] = useState<CmsResource | null>(null);
  const [assignment, setResourceAssignment] = useState<Assignment | null>(null);
  const [annotations, setAnnotations] = useState<string | undefined>(undefined);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [resourceRef, setResourceRef] = useState<Object>(useRef());
  const [language, setLanguage] = useState<string | undefined>();
  const resourceView = useResourceView(resource, language);
  const visibilityConfig = useVisibilityConfig(resourceView, assignment);
  const value = useMemo(() => ({
    assignment,
    setResourceAssignment,
    resource,
    setResource,
    language,
    setLanguage,
    visibilityConfig,
    annotations,
    setAnnotations,
    resourceRef,
    setResourceRef,
    dataLoaded,
    setDataLoaded,
    resourceView
  }), [assignment, resource, annotations, language, visibilityConfig, dataLoaded]);
  return <ResourceViewerContext.Provider value={value}>{children}</ResourceViewerContext.Provider>;
};
export const useResourceViewer = (): ResourceViewerContextType => {
  const context = useContext(ResourceViewerContext);
  if (!context) {
    throw new Error('useResourceViewer must be used within a ResourceViewerProvider');
  }
  return context;
};